import {
  AppSyncFarm,
  AppSyncFarmToken,
  MonitorVaults,
} from 'common/models/farm';
import React from 'react';
import { TokenIcon } from '../TokenIcons/TokenIcon';
import { FarmUtils } from 'utils/farmUtils';
import { ChainId } from 'constants/constants';
import VaultTooltip from './VaultTooltip';

type Props = {
  farms: AppSyncFarm[];
  monitorVaults: MonitorVaults[];
  depositToken: AppSyncFarmToken;
  onGetStarted: () => void;
  chainId: ChainId;
};

const GetStarted: React.FC<Props> = (props) => {
  const depositToken = props.depositToken;
  // exception for ETH vault: either ETH or wETH could be deposited
  const isEthVault =
    depositToken.displayName === 'wETH' && props.chainId !== ChainId.Polygon &&
    props.chainId !== ChainId.Celo;
  const depositTokenDisplayName = isEthVault ? 'ETH' 
    : (depositToken.displayName === 'ETHC' ? 'ETH' : depositToken.displayName);

  const farmsByDepositToken = props.farms.filter(
    (f) => FarmUtils.getBaseToken(f).address === depositToken.address
  );
  const maxApr = Math.max(
    ...farmsByDepositToken.map(
      (f) =>
        FarmUtils.getFeeAprByVaultAddress(props.monitorVaults, f.lpAddress) ?? 0
    )
  );
  const apr = (maxApr > 0 ? maxApr : 0).toFixed(2);
  const aprStatement =
    maxApr > 0.01 ? (
      <div className="text-lg font-semibold m-6">
        ${depositTokenDisplayName} vault has a{' '}
        <span className="text-[#1DBC7D]">{apr}%</span> 7-day fee APR (Annual Percentage Rate).
      </div>
    ) : null;

  return (
    <>
      <TokenIcon
        name={depositToken.name}
        width="118px"
        marginLeft="auto"
        marginRight="auto"
      />
      <div className="text-3xl font-semibold m-6">
        EARN with {depositTokenDisplayName}
      </div>
      {aprStatement}
      <div>
        It's easy, just complete the following steps to deposit.
        <br />
        <br />
        1. Select tokens
        <br />
        2. Approve spend
        <br />
        3. Confirm Deposit
      </div>
      <button
        className="primary-button-bg-color m-12 py-[10px] px-10 rounded-[10px]"
        type="button"
        onClick={props.onGetStarted}
        data-dd-action-name="Add Liquidity Modal"
      >
        <span className="primary-button-color">Get Started</span>
      </button>

      <VaultTooltip
        depositTokenDisplayName={depositToken.displayName}
        chainId={props.chainId}
      />
    </>
  );
};

export default GetStarted;
